import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card-title mt-4" }
const _hoisted_2 = { class: "badge bg-primary" }
const _hoisted_3 = { class: "col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 mt-4" }
const _hoisted_4 = ["alt", "src"]
const _hoisted_5 = { class: "d-flex justify-content-center mt-2" }
const _hoisted_6 = { class: "progress w-50" }
const _hoisted_7 = ["aria-valuenow"]
const _hoisted_8 = { class: "d-flex justify-content-center" }
const _hoisted_9 = { style: {"font-size":".8rem"} }
const _hoisted_10 = { class: "col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 d-flex align-items-center mt-3" }
const _hoisted_11 = { class: "card-body text-md-start text-lg-start text-xl-start" }
const _hoisted_12 = { class: "card-text" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" types ")
const _hoisted_14 = { class: "card-text" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("height ")
const _hoisted_16 = { class: "card-text" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("weight ")
const _hoisted_18 = { class: "card-text" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("base experience ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h5", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.pokemon.name) + " ", 1),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.pokemon.id), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        class: "img-fluid rounded-start mt-4",
        style: {"width":"40%"},
        alt: _ctx.pokemon.name,
        src: `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/${ _ctx.pokemon.id }.png`
      }, null, 8, _hoisted_4),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats, (stat) => {
        return (_openBlock(), _createElementBlock("div", {
          key: stat.name
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: "progress-bar",
                style: _normalizeStyle(`width:${ stat.baseStat*100/185 }%;`),
                role: "progressbar",
                "aria-valuenow": stat.baseStat,
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, _toDisplayString(stat.baseStat), 13, _hoisted_7)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("small", _hoisted_9, _toDisplayString(stat.name), 1)
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("p", _hoisted_12, [
          _hoisted_13,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (type) => {
            return (_openBlock(), _createElementBlock("span", {
              key: type,
              class: "badge rounded-pill bg-primary",
              style: {"margin-right":"5px"}
            }, _toDisplayString(type), 1))
          }), 128))
        ]),
        _createElementVNode("p", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("strong", null, _toDisplayString(_ctx.pokemon.height), 1)
        ]),
        _createElementVNode("p", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("strong", null, _toDisplayString(_ctx.pokemon.weight), 1)
        ]),
        _createElementVNode("p", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("strong", null, _toDisplayString(_ctx.pokemon.base_experience), 1)
        ])
      ])
    ])
  ], 64))
}